<template>
  <div class="expansion-panel">
    <div class="expansion-panel__body">
      <!-- header -->
      <div class="expansion-panel__header" :class="expandedClass">
        <slot name="panel-header" :toggleTransitionCollapse="toggleTransitionCollapse" />
      </div>
      <!-- body -->
      <TransitionCollapse :time="transitionDuration">
        <slot v-if="visible" name="panel-body" />
      </TransitionCollapse>
    </div>
    <!-- footer -->
    <div class="expansion-panel__footer">
      <slot name="panel-footer" />
    </div>
  </div>
</template>

<script>
import TransitionCollapse from 'Mixins/TransitionCollapse'

export default {
  name: 'ExpansionPanel',

  mixins: [TransitionCollapse],

  computed: {
    expandedClass() {
      return this.visible ? 'expanded' : ''
    },
  },
}
</script>

<style scoped></style>
